import SHA256 from "crypto-js/sha256";

export const getHashedPassword = (checkSum: string) =>
  "@RMH" + SHA256(checkSum).toString();
